
import React, { useState, useContext, useMemo, useCallback, useEffect, useRef, useLayoutEffect } from "react"
import { AppContext } from '../../../context'
import { themeColor } from "../../layout/global-style";
import Logo from '../../atoms/logo/index'
import { Subtitle } from '../../atoms/subtitle/index'
import { Compass } from "../../atoms/compass/index"

import {
  Container,
  Content,
  ListContainer,
  LogoContainer,
  Wrapper,
  PageChunkContainer,
  PageContainer,
  PageThumbnail,
  PageLabel, PageThumbnailBorder,
  Header, TitleContainer
} from './styles';
import scrollIntoView from 'scroll-into-view-if-needed';

import { FormattedMessage } from "gatsby-plugin-intl";
import { Fade } from "../../atoms/fade";
import Title from '../../atoms/title/index'

const chunk = (array, size) => new Array(Math.ceil(array.length / size)).fill().map((_, i) => array.slice(i * size, i * size + size));

const PageItem = ({ hover, pageMode, label, linkTo, page, isLeft, current, ...props }) => {
  const { thumbnail } = page;
  const { setCurrent, setTableOfContents } = useContext(AppContext);
  const [clicked, setClicked] = useState(false);

  const transitionTimerRef = useRef();
  const transitionDuration = 100;

  useEffect(() => {
    if (clicked) {

      clearTimeout(transitionTimerRef.current);
      function tick() {
        setTableOfContents(false);
      }
      transitionTimerRef.current = setTimeout(tick, transitionDuration);
      return () => {
        clearTimeout(transitionTimerRef.current);
      }

    }
  }, [clicked])

  const onClick = useCallback(
    () => {
      setCurrent(linkTo);
      setClicked(true);
    },
    [setCurrent, setTableOfContents, linkTo],
  )

  const noLeft = !pageMode && !isLeft;
  const noRight = !pageMode && isLeft;

  return (
    <PageContainer noLeftMargin={noLeft} noRightMargin={noRight} onClick={onClick} {...props}>
      <PageThumbnailBorder hover={hover} current={current} noLeftBorder={noLeft} noRightBorder={noRight}>
        <PageThumbnail src={thumbnail} />
      </PageThumbnailBorder>
      <PageLabel hover={hover} current={current}>{label}</PageLabel>
    </PageContainer>
  )
}

const getLabel = (index) => `${index}`/*.padStart(2, '0')*/;

const PageChunk = ({ pageMode, index, pages }) => {
  const { current, pageStep } = useContext(AppContext);
  const [hover, setHover] = useState(false);
  const [hoverLeft, setHoverLeft] = useState(false);
  const handleHover = useCallback((isLeft, isOver) => (e) => {
    if (!isLeft || !pageMode) {
      setHover(isOver)
    }

    if (isLeft || !pageMode) {
      setHoverLeft(isOver)
    }

  }, [setHover]);

  const PageItems = pages.map((page, i) => {
    const isLeft = i === 0;
    const ii = index + i;
    const isCurrent = current === ii || !pageMode && !isLeft && (current + 1) === ii
    const label = pageMode ? getLabel(ii + 1) : isLeft ? `${getLabel(ii / pageStep + 1)}` : ``;
    return <PageItem
      pageMode={pageMode} key={i} isLeft={isLeft} label={label} linkTo={index + (pageMode ? i : 0)} page={page} hover={isLeft ? hoverLeft : hover}
      onMouseEnter={handleHover(isLeft, true)}
      onMouseLeave={handleHover(isLeft, false)}
      current={isCurrent}
    />
  });

  const ref = useRef();
  useLayoutEffect(() => {
    const currentIndex = Math.floor(current / 2) * 2;
    if (ref.current && currentIndex === index && currentIndex > 2) {
      scrollIntoView(ref.current, {
        scrollMode: 'always',
        behavior: 'instant',
      });
      setTimeout(() => {
        scrollIntoView(ref.current, {
          scrollMode: 'always',
          behavior: 'instant',
        });
      }, 1);
    }
  }, [current]);

  return (
    <PageChunkContainer ref={ref}>
      {PageItems}
    </PageChunkContainer>
  )
}

const TableOfContents = ({ pageMode }) => {
  const { pages } = useContext(AppContext);
  const chunkSize = 1;
  const pageChunks = useMemo(() => chunk(pages, chunkSize), [pages, chunkSize]);
  const ListPageChunks = pageChunks.map((pages, index) => <PageChunk pageMode={pageMode} key={index} index={index * chunkSize} pages={pages} />);
  return (
    <ListContainer>
      {ListPageChunks}
    </ListContainer>
  )
}

export const TableOfContentsPage = ({ isOpen, pageMode }) =>
  <Fade isShow={isOpen}>
    <Container >
      <Compass />
      <Wrapper>
        <Content>
          <Header>
            <LogoContainer>
              <Logo />
            </LogoContainer>
            <TitleContainer>
              <Title color={themeColor.black} messageid={"app.title"} />
              <Subtitle color={themeColor.black}><FormattedMessage id="app.subtitle" /></Subtitle>
            </TitleContainer>
          </Header>
          <TableOfContents pageMode={pageMode} />
        </Content>
      </Wrapper>
    </Container>
  </Fade>

export default () => {
  const { tableOfContents, pageStep } = useContext(AppContext)
  return (
    <TableOfContentsPage isOpen={tableOfContents} pageMode={pageStep === 1} />
  )
};
